export default __webpack_public_path__ + "static/media/springPad.45899c76.png";